import { ThemeEvents } from '@theme/events';

class RegearBuyingDetails extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.closest('.shopify-section')?.addEventListener(ThemeEvents.variantUpdate, (event) => {
      const data = event.detail?.data;
      if (!data || String(data.productId) !== this.dataset.productId) return;
      const fresh = data.html?.querySelector('regear-buying-details');
      if (fresh) this.replaceChildren(...Array.from(fresh.childNodes, node => node.cloneNode(true)));
    }, { signal: this.controller.signal });
  }
  disconnectedCallback() { this.controller?.abort(); }
}
if (!customElements.get('regear-buying-details')) customElements.define('regear-buying-details', RegearBuyingDetails);
